// REGISTRATION

export const AFFILIATOR_REGISTRATION = 'AFFILIATOR_REGISTRATION';
export const AFFILIATOR_REGISTRATION_FORM = 'AFFILIATOR_REGISTRATION_FORM';
export const BUYER_REGISTRATION = 'BUYER_REGISTRATION';
export const BUYER_REGISTRATION_FORM = 'BUYER_REGISTRATION_FORM';
export const SELLER_REGISTRATION = 'SELLER_REGISTRATION';
export const SELLER_REGISTRATION_FORM = 'SELLER_REGISTRATION_FORM';
export const GET_ERRORS = 'GET_ERRORS';
export const SUCCESS_ALERT = 'SUCCESS_ALERT';

// FORGET PASSWORD

export const FORGET_PASSWORD = 'FORGET_PASSWORD';
// export const CONFIRM_PASSWORD = 'CONFIRM_PASSWORD';

// LOGIN

export const SELLER_LOGIN = 'SELLER_LOGIN';
export const BUYER_LOGIN = 'BUYER_LOGIN';

//PRODUCT UPLOAD

export const PRODUCT_UPLOAD = 'PRODUCT_UPLOAD';
export const GET_CATEGORIES = 'GET_CATEGORIES';

//FETCH PRODUCT
export const GET_PRODUCTS = 'GET_PRODUCTS';
